<div class="company-container">
  <div class="top-part">
    <div class="top-part-wrap">
      <div class="first-section">
        <h5 class="table-title">Sizes</h5>
      </div>
      <div class="second-section d-flex align-items-center justify-content-end">
        <span matTooltip="Export Data" matTooltipPosition="above">
          <button class="btn filter-btn ms-2" (click)="exportsizes()">
            <img
              style="width: 22px"
              src="../../../assets/Pricingscreen/export.svg"
            />
          </button>
        </span>
        <span matTooltip="Filter Data" matTooltipPosition="above">
          <button
            class="btn filter-btn ms-2"
            data-bs-target="#filterData"
            data-bs-toggle="modal"
            (click)="openFilterModal('Open')"
          >
            <i
              ><img
                style="width: 25px"
                src="../../../assets/Pricingscreen/filter.svg"
            /></i>
          </button>
        </span>
        <ng-template [ngxPermissionsOnly]="['Size:Create']">
          <div
            class="create-btn ms-2 c-pt"
            data-bs-target="#addSizeModal"
            data-bs-toggle="modal"
            (click)="resetFields()"
          >
            <img src="../../../../../assets/icons/whitePlus.svg" />
            Add New
          </div>
        </ng-template>
        <div class="dropdown custom-left ms-2">
          <button
            class="btn dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            id="removeContent"
            matTooltip="More Options"
            matTooltipPosition="above"
            matTooltipClass="raised-tooltip"
          >
            <img src="../../../../assets/Pos-Catalog/importdots.svg" />
          </button>
          <div class="dropdown-menu" id="firstDropdown">
            <div class="first-part">
              <ul class="dropdown-list list-unstyled mb-0">
                <li>
                  <a class="dropdown-item" (click)="exportSizes()"
                    ><img
                      class="me-3"
                      src="../../../../assets/Pos-Catalog/arrowDown.svg"
                    />Download Template</a
                  >
                </li>
                <li>
                  <a class="dropdown-item" (click)="importSizes()"
                    ><img
                      class="me-3"
                      src="../../../../assets/Pos-Catalog/arrowDown.svg"
                    />Import Sizes</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <section class="intro">
    <div class="table-container">
      <table class="table category-table table-condensed" id="mainParent">
        <thead class="main-head sticky-top">
          <tr>
            <th scope="col" style="align-items: center; text-transform: none">
              Departments
              <img
                style="margin: 0 0 2px 1px; cursor: pointer"
                src="../../../assets/Pricingscreen/sorting_val.svg"
                (click)="sortValues('deptDesc')"
              />&nbsp;
              <i
                class="fa-regular fa-circle-xmark text-danger"
                (click)="clearFilter()"
                *ngIf="departmentIDsToFilter.length > 0 && isFilterApplied"
              ></i>
            </th>
            <th scope="col" style="text-transform: none">
              Categories
              <img
                style="margin: 0 0 2px 1px; cursor: pointer"
                src="../../../assets/Pricingscreen/sorting_val.svg"
                (click)="sortValues('ctgDesc')"
              />&nbsp;
            </th>
            <th style="text-transform: none">Size & Range</th>
            <th scope="col" style="text-transform: none">Created On</th>
            <!-- <th scope="col">Created By</th> -->
            <ng-template [ngxPermissionsOnly]="['Size:Update']">
              <th scope="col" style="text-align: center">Actions</th>
            </ng-template>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let size of sizes; let i = index">
            <td class="d-flex g-2" colspan="2" style="align-items: center">
              <label for="" style="font-size: 14px; font-weight: 700">{{
                size.departmentDescr
              }}</label>
            </td>
            <td>{{ size.categoryName }}</td>
            <td>
              <div class="d-flex align-items-center">
                <span
                  *ngFor="
                    let sizeObj of sizes[i].sizing.slice(0, 3);
                    let last = last
                  "
                  >{{ sizeObj.alphaSize }}{{ !last ? ", " : "" }} &nbsp;</span
                >
                <span
                  class="c-pt"
                  style="color: #175f91; font-weight: 600"
                  (click)="getSizeByCategory(size)"
                  data-bs-target="#viewSizesModal"
                  data-bs-toggle="modal"
                  *ngIf="sizes[i].sizing.length > 3"
                  >+{{ sizes[i].sizing.length - 3 }}</span
                >
              </div>
            </td>
            <td>{{ sizes[i].sizing[0].createdDt | date : "MM/dd/yyyy" }}</td>
            <td style="text-align: center">
              <ng-template [ngxPermissionsOnly]="['Size:Update']">
                <div class="btn-group dropleft">
                  <span matTooltip="Edit Record" matTooltipPosition="above">
                    <button
                      type="button"
                      class="action-drop me-2"
                      data-bs-target="#addSizeModal"
                      data-bs-toggle="modal"
                      (click)="getSizeByCategory(size)"
                    >
                      <i
                        ><img
                          width="25"
                          src="../../../assets/Pricingscreen/update.svg"
                      /></i>
                    </button>
                  </span>
                </div>
              </ng-template>
            </td>
          </tr>
        </tbody>
      </table>
      <div
        *ngIf="sizes.length == 0"
        class="nodata"
        style="
          height: 56vh;
          width: 100%;
          display: flex;
          margin: auto;
          align-items: center;
          margin: auto;
          border: none;
        "
      >
        <p
          style="
            margin: auto;
            border: transparent !important;
            font-size: 2rem;
            color: #a4a4a4;
          "
        >
          No Data Available
        </p>
      </div>
    </div>
  </section>
</div>

<!--Boostrap modal for add new size-->
<div
  class="modal fade"
  id="addSizeModal"
  aria-hidden="true"
  aria-labelledby="exampleModalToggleLabel"
  tabindex="-1"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="custom-modal-header modal-header">
        <h5 class="mb-0">{{ frmText }}</h5>
      </div>
      <div class="modal-body px-0 pb-0">
        <div class="modal-body-wraapper pt-2 pb-4">
          <div class="d-flex align-items-center">
            <div class="dropdown custom-select me-3">
              <button
                class="btn dropdown-toggle d-flex justify-content-between align-items-center"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                [class.disabled]="frmText == 'Update Sizes'"
                [disabled]="frmText == 'Update Sizes'"
              >
                <span>{{
                  departmentIdToGetCategories > 0
                    ? selectedDepartment
                    : "Select Department"
                }}</span>
                <img src="../../../../../assets/icons/custom-drop.svg" />
              </button>
              <ul class="dropdown-menu">
                <li
                  class="py-1 c-pt d-flex flex-nowrap"
                  *ngFor="let department of departmentsList"
                  (click)="getCategoriesForDropdown(department.departmentId)"
                >
                  <input
                    class="form-check-input"
                    type="radio"
                    name="departmentDropdown"
                    [id]="department.departmentId"
                    (click)="selectedDept(department.departmentDescr)"
                    [(ngModel)]="departmentIdToGetCategories"
                    [value]="department.departmentId"
                  />
                  <label
                    class="form-check-label ps-2 w-100 c-pt"
                    [for]="department.departmentId"
                  >
                    {{ department.departmentDescr }}
                  </label>
                </li>
              </ul>
            </div>
            <div class="dropdown custom-select ms-2">
              <button
                class="btn dropdown-toggle d-flex justify-content-between align-items-center"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                [class.disabled]="
                  categories.length <= 0 ||
                  departmentIdToGetCategories <= 0 ||
                  frmText == 'Update Sizes'
                "
                [disabled]="
                  categories.length <= 0 ||
                  departmentIdToGetCategories <= 0 ||
                  frmText == 'Update Sizes'
                "
              >
                <span>{{
                  categoryId > 0 ? selectedCategoryName : "Select Category"
                }}</span>
                <img src="../../../../../assets/icons/custom-drop.svg" />
              </button>
              <ul class="dropdown-menu">
                <li
                  class="py-1 c-pt d-flex flex-nowrap"
                  *ngFor="let category of categories"
                >
                  <input
                    class="form-check-input"
                    type="radio"
                    name="categoriesDropdown"
                    [id]="category.categoryId"
                    (click)="selectedCategory(category.categoryName)"
                    [(ngModel)]="categoryId"
                    [value]="category.categoryId"
                  />
                  <label
                    class="form-check-label ps-2 w-100 c-pt"
                    [for]="category.categoryId"
                  >
                    {{ category.categoryName }}
                  </label>
                </li>
              </ul>
            </div>
          </div>
          <div class="mt-3" id="addSizeWrapper">
            <table class="table mb-0" style="border-bottom: none">
              <thead class="sticky-top">
                <tr>
                  <th class="ps-4" scope="col">Sizes</th>
                  <th scope="col">Ranges</th>
                  <th scope="col" style="width: 20%">Action</th>
                  <th class="text-center" scope="col"></th>
                </tr>
              </thead>
              <tbody cdkDropList (cdkDropListDropped)="drropSizeRow($event)">
                <tr
                  class="drag-row"
                  *ngFor="let size of addSizeArray; let i = index"
                  cdkDrag
                >
                  <td class="ps-4 py-2">
                    <input
                      class="form-control"
                      type="text"
                      (keyup)="showBtns()"
                      [(ngModel)]="addSizeArray[i].alphaSize"
                      placeholder="Enter Size"
                      [disabled]="categoryId == 0"
                    />
                    <p
                      class="text-danger pt-1"
                      style="font-size: 10px"
                      *ngIf="isAllFieldNotFill"
                    >
                      Please Fill Size Name
                    </p>
                  </td>
                  <td style="text-align: center; vertical-align: middle">
                    <input
                      class="form-control"
                      type="text"
                      [(ngModel)]="addSizeArray[i].numericSizeRange"
                      placeholder="Enter Range"
                      [disabled]="categoryId == 0"
                    />
                  </td>
                  <td class="align-middle">
                    <i
                      class="c-pt"
                      matTooltip="Delete"
                      matTooltipPosition="above"
                      ><img
                        (click)="deleteSizeRow(i)"
                        width="20"
                        src="../../../assets/Pricingscreen/delete.svg"
                    /></i>
                  </td>
                  <td class="text-center align-middle pe-3">
                    <img
                      class="drag-ic"
                      src="../../../../../assets/icons/ic_dragDrop.svg"
                      style="cursor: all-scroll"
                      cdkDragHandle
                      matTooltip="Drag to reorder"
                      matTooltipPosition="above"
                      matTooltipClass="raised-tooltip"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="py-2 add-one">
            <div class="pt-1">
              <span
                class="ps-3 c-pt"
                style="color: #175f91; font-weight: 600"
                (click)="addSizeRow()"
                >+ Add Size</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="custom-modal-footer modal-footer mt-0">
        <button
          class="btn modal-btn me-2"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          Cancel
        </button>
        <button
          class="modal-btn disable-btn me-2"
          *ngIf="
            (!showAddUpdateBtn && frmText == 'Add New Sizes') ||
            departmentIdToGetCategories == 0 ||
            categoryId == 0
          "
        >
          Add Sizes
        </button>
        <button
          class="btn modal-btn add-btn"
          (click)="addUpdateSizes()"
          data-bs-dismiss="modal"
          aria-label="Close"
          *ngIf="
            showAddUpdateBtn &&
            frmText == 'Add New Sizes' &&
            departmentIdToGetCategories > 0 &&
            categoryId > 0
          "
        >
          Add Sizes
        </button>
        <button
          class="modal-btn disable-btn me-2"
          *ngIf="!showAddUpdateBtn && frmText == 'Update Sizes'"
        >
          Update Sizes
        </button>
        <button
          class="btn modal-btn add-btn w-auto"
          data-bs-dismiss="modal"
          aria-label="Close"
          *ngIf="showAddUpdateBtn && frmText == 'Update Sizes'"
          (click)="addUpdateSizes()"
        >
          Update Sizes
        </button>
      </div>
    </div>
  </div>
</div>

<!--Boostrap modal for view sizes-->
<div
  class="modal fade"
  id="viewSizesModal"
  aria-hidden="true"
  aria-labelledby="exampleModalToggleLabel"
  tabindex="-1"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="custom-modal-header modal-header">
        <h5 class="mb-0">Size & Range</h5>
      </div>
      <div class="modal-body">
        <div class="modal-body-wraapper">
          <section>
            <div id="sizingTblWrapper">
              <table class="table mb-0" style="border-bottom: none">
                <thead class="sticky-top">
                  <tr>
                    <th scope="col">Size</th>
                    <th scope="col" style="text-align: center">Range</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let size of sizeDetails">
                    <td class="d-flex g-2 ps-2 py-3">
                      <span>{{ size.alphaSize }}</span>
                    </td>
                    <td style="text-align: center; vertical-align: middle">
                      {{ size.numericSizeRange }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        </div>
      </div>
      <div class="modal-footer d-flex justify-content-end" id="categoriesBtn">
        <button
          class="btn modal-btn py-3"
          style="width: 95px"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          Ok
        </button>
      </div>
    </div>
  </div>
</div>

<!--Boostrap modal for filter data-->
<div
  class="modal fade"
  id="filterData"
  aria-hidden="true"
  aria-labelledby="exampleModalToggleLabel"
  tabindex="-1"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="mb-0">Filters</h5>
      </div>
      <div class="modal-body p-0">
        <div class="filter d-flex">
          <div class="filter-labels">
            <h6 class="ps-4">Lists</h6>
            <div class="filter-labels-wrapper">
              <ul class="list-unstyled">
                <li class="active">
                  Department
                  <br />
                  <p *ngIf="departmentIDsToFilter.length > 0">
                    {{ departmentIDsToFilter.length }} selected
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <div class="filter-data">
            <h6 class="ps-2">Selected by: Department</h6>
            <div class="filter-data-wrapper">
              <div class="row">
                <div
                  class="col-lg-3 col-sm-6"
                  *ngFor="let data of deptArrayForFilters; let idx = index"
                  (click)="collectFilterParameters(data.departmentId)"
                >
                  <div
                    class="conntent-box"
                    [ngClass]="{ active: data.isSelected == true }"
                  >
                    <i><img class="filtericon" [src]="data.dImageIcon" /></i>
                    <span
                      class="mt-2 text-center"
                      style="font-size: 13px; color: black"
                      >{{ data.departmentDescr }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer d-flex justify-content-end">
        <div class="footer-wrapper">
          <button
            class="btn modal-btn me-2"
            data-bs-dismiss="modal"
            aria-label="Close"
            style="background-color: #ffffff; color: rgb(23, 95, 145)"
            (click)="openFilterModal('Close')"
          >
            Cancel
          </button>
          <button
            class="btn modal-btn me-2"
            data-bs-dismiss="modal"
            aria-label="Close"
            [disabled]="!departmentIDsToFilter.length"
            style="background-color: rgb(23, 95, 145); color: white"
            (click)="getFilterData()"
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<input
  class="d-none"
  #importSize
  type="file"
  accept=".xlsx, .xls, .csv"
  (change)="onFileChangeImport($event)"
/>
<!-- Button trigger modal -->
<button
  #importModel
  type="button"
  class="btn btn-primary d-none"
  data-bs-toggle="modal"
  data-bs-target="#addbulkuserModal"
></button>
<!-- Modal -->
<div
  class="modal fade"
  id="addbulkuserModal"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
  data-bs-backdrop="static"
>
  <div
    class="modal-dialog modal-dialog-centered modal-dialog-scrollable custom-modal-dialog"
    style="max-width: 50%"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="addbulkuserModalLabel">
          Import Departments
        </h5>

        <button
          type="button"
          class="btn-close"
          data-bs-toggle="modal"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="closeImportModal()"
        ></button>
      </div>
      <div class="modal-body">
        <div class="tbl-container">
          <table class="table">
            <thead class="sticky-top">
              <tr>
                <th
                  scope="col"
                  style="display: flex; align-items: center; gap: 7px"
                >
                  <input
                    [(ngModel)]="toggleAll"
                    [disabled]="isImportDisabled"
                    type="checkbox"
                    class="form-check-input formMaster mod m-0"
                    (click)="checkAllImport($event)"
                  />
                  Size Description
                </th>
                <th scope="col">Department</th>
                <th scope="col">Category</th>
                <th scope="col">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let size of importsizes; let i = index">
                <td style="display: flex; align-items: center; gap: 7px">
                  <input
                    (click)="isImportEnabled()"
                    [disabled]="size.status == 1 || size.status == 0"
                    type="checkbox"
                    class="form-check-input formItem mod m-0"
                    [(ngModel)]="size.isChecked"
                  />
                  <ng-container *ngIf="size.size != null">
                    {{ size.size }}
                  </ng-container>
                </td>
                <td>{{ size.departmentDesc }}</td>
                <td>{{ size.category }}</td>
                <td
                  class="tooltip-container"
                  style="
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    flex-direction: column;
                  "
                  [ngStyle]="{
                    color:
                      size.status === null
                        ? '#FFCA28'
                        : size.status === true
                        ? '#66BB6A'
                        : '#EF5350'
                  }"
                >
                  <div style="display: flex; gap: 6px">
                    <img
                      *ngIf="size.status != null"
                      [src]="
                        size.status === false
                          ? '../../../../assets/products-imgs/redError.svg'
                          : size.status === true
                          ? '../../../../assets/products-imgs/greenCheck.svg'
                          : ''
                      "
                      alt="Status Image"
                      style="width: 25px; height: 25px; object-fit: contain"
                    />

                    <ng-container class="tooltip-button">
                      <ng-container *ngIf="size.status === null">
                        Not added to database
                      </ng-container>
                      <ng-container *ngIf="size.status === true">
                        {{
                          size.reason[0] == "New size created"
                            ? "Added to database"
                            : size.reason[0] == "Existing size updated"
                            ? "Existing size updated"
                            : ""
                        }}
                      </ng-container>
                      <ng-container *ngIf="size.status === false">
                        <!-- Show first error -->
                        {{ size.reason[0].split("|")[0] }}

                        <!-- Show +count if more errors exist -->
                        <span
                          *ngIf="size.reason[0].split('|').length > 1"
                          class="error-count-tooltip"
                          [matTooltip]="getRemainingErrors(size.reason[0])"
                          matTooltipClass="error-tooltip"
                        >
                          +{{ size.reason[0].split("|").length - 1 }}
                        </span>
                      </ng-container>
                    </ng-container>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-footer">
        <button
          [disabled]="isImportDisabled"
          class="btn"
          (click)="addImportedDepartments()"
          style="
            background-color: #0070b9;
            color: white;
            display: flex;
            align-items: center;
            gap: 6px;
          "
        >
          <img src="../../../../assets/products-imgs/downloadIcon.svg" /> Import
          selected Size(s)
        </button>
      </div>
    </div>
  </div>
</div>
